<!--超市选择-->
<template>
    <Modal
            v-model="modal"
            :title="title"
            @on-cancel="cancel"
            :footer-hide="true">
        <Input v-model="searchName" placeholder="请输入超市名称" search enter-button @on-search="handleClickCusSelect"></Input>
        <CTable :height="400" :columns="columns" :data="queryData"
                :showPage="false"/>
    </Modal>
</template>

<script>

    import CTable from '../CTable'

    export default {
        name: "CusSelectDialog",
        model: {},
        components: {
            CTable
        },
        props: {
            bindCusCode: {
                type: String
            },
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: "超市选择"
            }
        },
        watch: {
            "visible"(newVal) {
                if (this.modal !== newVal)
                    this.modal = newVal
                if (newVal) {
                    this.searchName = ''
                }
            },
            "modal"(newVal) {
                if (newVal) {
                    this.loadDataByName(null)
                }
                this.$emit("update:visible", newVal)
            }
        },
        data() {
            return {
                searchName: '',
                modal: false,
                queryData: [],
                columns: [{
                    title: '超市名称',
                    key: 'superName'
                },
                    {
                        title: '操作',
                        key: 'action',
                        fixed: 'right',
                        width: 160,
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    on: {
                                        click: () => {
                                            this.$emit("on-select", params.row)
                                        }
                                    }
                                }, '选择')
                            ])
                        }
                    }]
            }
        },
        methods: {
            ok() {

            },
            cancel() {
            },
            loadDataByName(value) {
                this.$fetch('SuperApply/getSuperByName', {
                    superName: value,
                    cusCode: this.bindCusCode
                }).then(res => {
                    this.queryData = res.data.list
                })


            },
            handleClickCusSelect() {
                this.loadDataByName(this.searchName)
            }
        }
    }
</script>

<style scoped>

</style>
